import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";

// Components
import Spinner from "../../Components/Loading/Spinner";

// Libraries
import { Form, InputGroup } from "react-bootstrap";


import moment from "moment/moment";

export default function ListInvoices() {
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();
    const params = useParams();

    const [loading, setLoading] = useState(true);
    const [invoices, setInvoices] = useState([]);

    const [isValid, setIsValid] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const [form, setForm] = useState({

    });
    const [formErrors, setFormErrors] = useState({

    });

    const setField = (field, value) => {
        console.log(field, value)
        setForm({
            ...form,
            [field]: value,
        });
    };

    


    // Load users
    useEffect(() => {
        loadInvoices()
    }, []);

    const handleSubmit = (event) => {

        console.log("handle submit", form)
        event.preventDefault();
        setSubmitting(true);

        setFormErrors({
            //dateOrdered: form.dateOrdered === undefined || form.dateOrdered === "" ? "Date ordered is required" : "",

        });
    }

    useEffect(() => {
        console.log("formErrors changed")
        setIsValid(true)
    }, [formErrors])

    useEffect(() => {
        console.log("isvalid changed", isValid)
        if (isValid && submitting) {
            console.log("submitting...", isValid)

            axios
                .put(`https://${process.env.REACT_APP_IP}/api/orders/${params.id}/invoices`, invoices, { headers: { Authorization: `bearer ${user.token}` } })
                .then((res) => {
                    console.log("response:", res);
                    setSubmitting(false);

                    if (res.status === 200) {
                        navigate(`/Orders/View/${params.id}`)
                    }
                })
                .catch((err) => {
                    console.log(err.response.data);
                    setSubmitting(false);



                    if (err.code === "ERR_NETWORK") {
                        setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                    }
                    else if (err.code === "ERR_BAD_REQUEST") {
                        setFormErrors(err.response.data.errors);
                    }
                    else {
                        setFormErrors({ general: "An unknown error occured. " + err.code });
                    }
                });
        }
    }, [isValid, submitting]);

    const handleInputChange = (index, field, value) => {
        console.log("changing " + field)


        const updatedItems = invoices.map((item, i) =>
            i === index ? {
                ...item,
                [field]: value
            } : item
        );
        setInvoices(updatedItems);

    };

    const handleAddRow = () => {
        console.log("add row")
        //setInvoices([...invoices, { id: invoices.length, productCode: "0", deleted: false }]);

        axios
            .post(`https://${process.env.REACT_APP_IP}/api/orders/${params.id}/invoices`, {}, { headers: { Authorization: `bearer ${user.token}` } })
            .then((res) => {
                console.log("response:", res);
                

                if (res.status === 200) {
                    setInvoices([...invoices, res.data ]);
                }
            })
            .catch((err) => {
                console.log(err.response.data);
                



                if (err.code === "ERR_NETWORK") {
                    setFormErrors({ general: "Connection to the server could not be established. Please try again in a few minutes" });
                }
                else if (err.code === "ERR_BAD_REQUEST") {
                    setFormErrors(err.response.data.errors);
                }
                else {
                    setFormErrors({ general: "An unknown error occured. " + err.code });
                }
            });
    }



    function loadInvoices(form) {
        console.log("loading invoices...", form);

        // Load the order details
        axios
            .get(`https://${process.env.REACT_APP_IP}/api/orders/${params.id}/Invoices`, {
                headers: { Authorization: `bearer ${user.token}` },
            })
            .then((res) => {
                console.log("Invoices:", res.data);
                setInvoices(res.data);
                setLoading(false);
            })
            .catch((err) => {
                console.log(err);


                if (err.response.status === 401) {
                    dispatch({ type: "LOGOUT" })
                    navigate("../")
                }
            });
    }

    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (


                        <div>
                            <Form onSubmit={handleSubmit} noValidate >
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Invoices</h3>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-12">
                                        <table width="100%">
                                            <thead>
                                                <tr>
                                                    <td>Invoice #</td>
                                                    <td>Description</td>
                                                    <td>Date Raised</td>
                                                    <td>Date Paid</td>
                                                    <td>Amount</td>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {invoices && invoices.map((item, index) => (

                                                    <tr key={item.id}>
                                                        <td>{item.id}</td>
                                                        {/* Description */}
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                value={item.description}
                                                                onChange={e => handleInputChange(index, 'description', e.target.value)}
                                                            />
                                                        </td>
                                                        {/* Date Raised */}
                                                        <td>
                                                            <Form.Control
                                                                type="date"
                                                                value={moment(item.dateRaised).format("YYYY-MM-DD")}
                                                                onChange={e => handleInputChange(index, 'dateRaised', e.target.value)}
                                                            />
                                                        </td>
                                                        {/* Date Paid */}
                                                        <td>
                                                            <Form.Control
                                                                type="date"
                                                                value={moment(item.datePaid).format("YYYY-MM-DD")}
                                                                onChange={e => handleInputChange(index, 'datePaid', e.target.value)}
                                                            />
                                                        </td>
                                                        {/* Amount */}
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                value={item.amount}
                                                                onChange={e => handleInputChange(index, 'amount', e.target.value)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>

                                        </table>
                                        <button type="button" className="btn btn-primary" onClick={handleAddRow}>Add Item</button>

                                    </div>
                                </div>


                                <div className="row" style={{ marginTop: 40 }}>
                                    <hr/>
                                    <div className="col-md-12">
                                        <button className="btn btn-primary" type="submit" >Save Changes</button>
                                        <button className="btn btn-other" style={{ marginLeft: 10 }} onClick={() => { navigate(`/Orders/View/${params.id}`) }}>Cancel</button>
                                    </div>
                                </div>
                            </Form>
                        </div>

        
                    )}
                </div>
            </div>
        </div>
    )
}